import Video from '@/data/Video';
import Videos from '@/data/Videos';

export default class VideosMapper {

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  public static mapFromVideosObjects(videosObj: any, offset?: number): Videos {
    
    if(videosObj.total === undefined) {
      throw new Error(`Can not map ${videosObj} to Videos instance.`);
    }
    const total = parseInt(videosObj.total);
    const videos = new Videos(total);
    if(total === 0) return videos;

    videos.videos.length = total;
    let startIndex = offset ? offset : 0;
    
    for(const videoObj of videosObj.videos) {
      const video = VideosMapper.mapFromVideoObject(videoObj);
      if(video) {
        videos.videos[startIndex++] = video;
      }
    }
    return videos;
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  public static mapFromVideoObject(videoObj: any): Video {

    if(videoObj.id === undefined) {
      throw new Error(`Can not map ${videoObj} to Video instance.`);
    }

    const video = new Video(videoObj.id);
    if(videoObj.title) video.title = videoObj.title;
    if(videoObj.thumbnail) video.thumbnailUrl = videoObj.thumbnail;
    if(videoObj.description) video.desc = videoObj.description;
    if(videoObj.createdDate) video.createdDate = videoObj.createdDate;
    if(videoObj.modifiedDate) video.modifiedDate = videoObj.modifiedDate;
    if(videoObj.uploadDate) video.uploadDate = videoObj.uploadDate;
    if(videoObj.publicationDate) video.publicationDate = videoObj.publicationDate;
    if(videoObj.plays) video.plays = videoObj.plays;
    if(videoObj.views) video.views = videoObj.views;
    if(videoObj.length) video.length = videoObj.length;
    if(videoObj.channels) {
      for(const channelId of videoObj.channels) {
        video.channels.push(channelId);
      }
    }
    if(videoObj.customMetaData) {
      for (const [key, value] of Object.entries(videoObj.customMetaData)) {
        video.customMetaData.set(key, value as string);
      }
    }
    if(videoObj.keywords) {
      /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
      video.keywords = videoObj.keywords.map((keyWordObj: any) => keyWordObj.text ? keyWordObj.text : '');
    }
    if(videoObj.stills) {
      for(const still of videoObj.stills) {
        if(still.quality === '720p') {
          video.posterUrl = still.url;
        }
      }
    }
    if(videoObj.priority) video.priority = videoObj.priority;

    return video;
  }

}